import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    item: {
      width: "100%",
      height: 54,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0 15px 0 24px",
      borderBottom: "1px solid #dddddd",
      cursor: "pointer",
      "&.active": {
        backgroundColor: "rgba(97, 198, 158, 0.15)"
      }
    },
    label: {
      color: primary.main
    },
    radio: {
      color: primary.main,
      "&.MuiRadio-colorSecondary.Mui-checked": {
        color: primary.main
      },
      "& .MuiSvgIcon-root": {
        width: 28,
        height: 28
      }
    }
  };
});
